import { BsHeaderTitle } from './BsHeaderTitle';
export default BsHeaderTitle;
